<template>
  <div>
    <v-card>
      <v-card-title>
        <v-icon color="primary"> mdi-credit-card-outline </v-icon>
        <span class="pl-2">{{ $t('pages.create_payment') }}</span>
        <v-spacer></v-spacer>
        <v-btn depressed color="secondary" @click="$router.go(-1)" class="mx-1">
          {{ $t('pages.back') }}
          <v-icon right dark> mdi-keyboard-return </v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-form
          ref="form"
          v-model="valid"
          class="multi-col-validation mt-6"
          lazy-validation
        >
          <v-row>
            <v-col md="6" cols="12">
              <v-autocomplete
                v-model="payment.student_id"
                :items="students"
                item-text="name"
                item-value="id"
                clearable
                dense
                outlined
                :label="$t('forms.students')"
                :rules="studentRules"
              ></v-autocomplete>
            </v-col>
            <v-col md="6" cols="12">
              <v-text-field
                v-model="payment.amount"
                :label="$t('forms.amount')"
                dense
                outlined
                required
                prefix="€"
                type="number"
                :rules="amountRules"
              ></v-text-field>
            </v-col>
            <v-col md="6" cols="12">
              <v-menu
                ref="monthsMenu"
                v-model="monthsMenu"
                :close-on-content-click="false"
                :return-value.sync="payment.months"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-combobox
                    v-model="payment.months"
                    multiple
                    dense
                    outlined
                    chips
                    small-chips
                    :label="$t('forms.months')"
                    append-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    :rules="monthsRules"
                  ></v-combobox>
                </template>
                <v-date-picker
                  v-model="payment.months"
                  type="month"
                  multiple
                  no-title
                  scrollable
                  :min="minDate"
                >
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="monthsMenu = false">
                    {{ $t('actions.cancel') }}
                  </v-btn>
                  <v-btn
                    text
                    color="primary"
                    @click="$refs.monthsMenu.save(payment.months)"
                  >
                    {{ $t('actions.ok') }}
                  </v-btn>
                </v-date-picker>
              </v-menu>
            </v-col>

            <v-col cols="12">
              <v-btn
                color="primary"
                class="me-3 mt-4"
                @click="savePayment"
                :loading="isCreating"
              >
                {{ $t('actions.save_changes') }}
              </v-btn>
              <v-btn color="secondary" outlined class="mt-4" @click="cancel">
                {{ $t('actions.cancel') }}
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import CreateButton from '@/components/CreateButton.vue';

export default {
  components: { CreateButton },
  data() {
    return {
      isCreating: false,
      payment: {
        student_id: null,
        amount: null,
        months: [],
      },
      valid: true,
      monthsMenu: null,
      students: [],
      studentRules: [(v) => !!v || this.$t('messages.is_required')],
      amountRules: [(v) => !!v || this.$t('messages.is_required')],
      monthsRules: [(v) => v.length > 0 || this.$t('messages.is_required')],
    };
  },
  mounted() {
    this.getAllStudents();
  },
  computed: {
    minDate: function () {
      const now = new Date();
      return now.toISOString().slice(0, 7);
    },
  },
  methods: {
    validate() {
      return this.$refs.form.validate();
    },
    getAllStudents() {
      axios
        .get('/users/all-students-list')
        .then((response) => {
          this.students = response?.data;
        })
        .catch(() => {
          this.$notify({
            title: 'Error',
            text: 'Error fetching students',
            type: 'error',
          });
        });
    },
    savePayment() {
      if (!this.validate()) return;
      this.isCreating = true;
      const data = { ...this.payment };
      axios
        .post(`/school/payments`, data)
        .then(() => {
          this.$notify({
            title: 'Success',
            text: 'Payment created!',
            type: 'success',
          });
          this.$router.go(-1);
        })
        .catch(() => {
          this.$notify({
            title: 'Error',
            text: 'Error creating payment',
            type: 'error',
          });
        })
        .then(() => {
          this.isCreating = false;
        });
    },
    cancel() {
      this.$router.go(-1);
    },
  },
};
</script>

<style lang="scss" scoped></style>
